import DataTile from "./DataTile";
import React from "react";
import {useSelector} from "react-redux";
import { fetchRequestedAttacks} from "../../../actions";
import {filterObject} from "../../../util/bbHelpers";
import BBIconCheckboxNo from "../../../assets/bbCustomIcons/BBIconCheckboxNo";

const Tile = (props) => {

    const {customerId} = props;

    /**************************/
    /*Setup State and Dispatch*/
    /**************************/
    const {customerInView} = useSelector(({customer}) => customer);

    const customerIdToUse = customerId ? customerId : customerInView;

    const colorFunction = (stateData) => {
        return "light";
    }

    const valueFunction = (stateData) => stateData ? stateData[customerIdToUse] ? Object.keys(filterObject(stateData[customerIdToUse], (key, attack) => attack.Status.Id === 7 || attack.Status.Id === 6)).length : null : null;

    // const translateValueToRisk = (value) => {
    //     if (typeof value !== "number") {
    //         return null
    //     } else if (value <= 5) {
    //         return 0
    //     } else if (value <= 15) {
    //         return 1
    //     } else if (value <= 24) {
    //         return 2
    //     } else if (value <= 40) {
    //         return 3
    //     } else {
    //         return 4
    //     }
    // }

    // const riskRibbon = (stateData) => {
    //     const num = translateValueToRisk(valueFunction(stateData));
    //     return num
    //         ? <RiskRibbon ratingBy5={num} />
    //         : null;
    // }

    return (
        <DataTile
            // color = {colorFunction()}
            colorBgFunction={colorFunction}
            subTitle="Attacks Aborted"
            tipText={`The number of Insider Attacks that were aborted by you or BreachBits.`}
            icon={<BBIconCheckboxNo style={{fontSize: "70px"}}/>}
            stateName="insider"
            stateElement="requestedAttacks"
            // useDeepDataStore
            // dontFetch
            // forceLoadingState = {true}
            // deepDataStore = {(dataStore) => dataStore? dataStore[customerIdToUse] ? dataStore[customerIdToUse] : null : null}
            stateLoaderName="loadingRequestedAttacks"
            stateLoaderError="loadingRequestedAttacksFail"
            stateFetchAction={fetchRequestedAttacks({
                customerId: customerIdToUse
            })}
            preventDataFetchConditionFunction={(dataStore) => !customerIdToUse}
            valueFunction={valueFunction}
            ribbonFunction={null}
        />
    )

}

export default Tile;